import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IInterviewer, IInterviewerCreate, IInterviewerUpdate } from '@tsin-core/states/interviewer/interviewer.models';
import { ConfigService } from '@tsin-core/services/common/config.service';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private http = inject(HttpClient);
  private configService = inject(ConfigService);

  private get apiUrl(): string {
    return this.configService.getConfig().apiUrl || environment.apiUrl2;
  }

  private get emailUrl(): string {
    return `${this.apiUrl}/email`;
  }


  // POST: Create a new interviewer
  sendEmail(input: { from: string, to: string[], subject: string, body: string }): Observable<any> {
    return this.http.post<any>(`${this.emailUrl}/send-bulk`, input);
  }

  // GET: Get email settings
  getSettings(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/settings`);
  }

  // POST: Disable all emails
  disableAllEmails(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/settings/disable-all-emails`, {});
  }

  // POST: Enable all emails
  enableAllEmails(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/settings/enable-all-emails`, {});
  }

  // POST: Toggle all emails
  toggleAllEmails(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/settings/toggle-all-emails`, {});
  }

  // GET: Get email status
  getEmailStatus(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/settings/email-status`);
  }

}
